<form novalidate [formGroup]="form" class="auth-form" (ngSubmit)="verifyOtp()">
  <div class="form-row" *ngIf="isVerifyOtpVisible">
    <div class="mat-subheading-2">{{ 'user.verify_phone' | translate }}</div>
    <mat-form-field appearance="fill">
      <mat-label>{{ 'user.otp' | translate }}</mat-label>
      <input matInput formControlName="otp" required />
      <mat-error [data-qa]="'invalid-otp'" *ngIf="form.get('otp')?.invalid">{{
        getErrorMessage('otp')
      }}</mat-error>
    </mat-form-field>
    <ng-container *ngIf="!isCountdownEnded; else requestNewOtp">
      <div class="request-new-otp">
        {{ 'user.otp_countdown' | translate }}
        <app-countdown-timer
          [deadline]="otpDeadline"
          (countdownFinished)="onOtpCountdownEnd()"
        ></app-countdown-timer>
      </div>
    </ng-container>
    <ng-template #requestNewOtp>
      <div class="request-new-otp">
        <mzima-client-button fill="clear" size="small" (buttonClick)="requestOtp()"
          ><span class="retry-request-otp">{{
            'user.request_new_otp' | translate
          }}</span></mzima-client-button
        >
      </div>
    </ng-template>
  </div>
  <div class="form-row" *ngIf="authType === 'password'">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'user.name' | translate }}</mat-label>
      <input matInput formControlName="name" required />
      <mat-error [data-qa]="'invalid-name'" *ngIf="form.get('name')?.invalid">{{
        getErrorMessage('name')
      }}</mat-error>
      <mat-hint>{{ 'user.name_will_be_a_display_name' | translate }}</mat-hint>
    </mat-form-field>
  </div>
  <div class="form-row" *ngIf="authType === 'password'">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'user.email' | translate }}</mat-label>
      <input matInput formControlName="email" required />
      <mat-error [data-qa]="'invalid-email'" *ngIf="form.get('email')?.invalid">{{
        getErrorMessage('email')
      }}</mat-error>
    </mat-form-field>
  </div>

  <div class="phone-wrapper" *ngIf="authType === 'phone' && !isVerifyOtpVisible">
    <div *ngIf="authType === 'phone' && !isVerifyOtpVisible" class="form-row input-with-prefix">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'user.phone' | translate }}</mat-label>
        <input
          matInput
          formControlName="phone"
          required
          (keydown.enter)="
            form.controls['phone'].invalid || form.disabled || submitted ? null : requestOtp()
          "
        />
        <mat-error [data-qa]="'invalid-phone'" *ngIf="form.get('phone')?.invalid">{{
          getErrorMessage('phone')
        }}</mat-error>
      </mat-form-field>
    </div>
    <div class="form-row input-prefix">
      <app-country-code-selector (countrySelected)="onCountrySelected($event)">
      </app-country-code-selector>
    </div>
  </div>
  <mat-error [data-qa]="'otp-verification-error'">{{ registrationError }}</mat-error>
  <div *ngIf="authType === 'password'" class="form-row">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'user.password' | translate }}</mat-label>
      <mzima-client-button
        matSuffix
        fill="clear"
        color="secondary"
        [iconOnly]="true"
        (buttonClick)="togglePasswordVisible()"
      >
        <mat-icon icon [svgIcon]="isPasswordVisible ? 'eye-open' : 'eye'"></mat-icon>
      </mzima-client-button>
      <input
        matInput
        formControlName="password"
        required
        [type]="isPasswordVisible ? 'text' : 'password'"
      />
      <mat-error [data-qa]="'invalid-password'" *ngIf="form.get('password')?.invalid">{{
        getErrorMessage('password')
      }}</mat-error>
      <mat-hint>{{ 'user.password_hint' | translate }}.</mat-hint>
    </mat-form-field>
    <app-password-strength [passwordToCheck]="form.value.password"></app-password-strength>
  </div>
  <div class="form-row" *ngIf="!isVerifyOtpVisible">
    <div class="checkbox">
      <mat-checkbox [data-qa]="'i-agree'" formControlName="agreement" required>
        <span [innerHTML]="'terms_of_service.i_agree' | translate"></span>
      </mat-checkbox>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <ng-content
      select="[btn-cancel]"
      *ngIf="!isVerifyOtpVisible || authType === 'password'"
    ></ng-content>

    <mzima-client-button
      *ngIf="isVerifyOtpVisible"
      (buttonClick)="goBack()"
      fill="outline"
      color="secondary"
    >
      {{ 'app.back' | translate }}
    </mzima-client-button>

    <mzima-client-button
      *ngIf="!isVerifyOtpVisible"
      (buttonClick)="requestOtp()"
      [disabled]="
        form.controls['phone'].invalid ||
        form.controls['agreement'].invalid ||
        form.disabled ||
        submitted
      "
      >{{ 'nav.register' | translate }}</mzima-client-button
    >

    <mzima-client-button
      *ngIf="isVerifyOtpVisible"
      type="submit"
      [disabled]="form.invalid || form.disabled || submitted"
      [data-qa]="'btn-register'"
    >
      {{ 'app.verify' | translate }}
    </mzima-client-button>
  </div>
</form>
